import React from 'react';
import * as Icons from 'lucide-react';
import { socialLinks } from '../../mock/data';

export default function FooterSocial() {
  return (
    <div className="flex items-center gap-3 mt-6">
      {socialLinks.map((s) => {
        const Icon = Icons[s.icon] || Icons.Link;
        return (
          <a
            key={s.id}
            href={s.href}
            aria-label={s.label}
            className="w-9 h-9 rounded-full bg-white/5 hover:bg-white/10 transition-colors flex items-center justify-center"
          >
            <Icon size={16} />
          </a>
        );
      })}
    </div>
  );
}
